// window.addEventListener('load', () => {
//   setTimeout(() => {
//     document.body.classList.add('page-loaded');
//   }, 1000);
// });

// const animationData = {
//   v: '5.12.1',
//   fr: 60,
//   ip: 44,
//   op: 245,
//   w: 1000,
//   h: 1000,
//   nm: 'Comp 1',
//   ddd: 0,
//   assets: [],
//   layers: [
//     {
//       ddd: 0,
//       ind: 1,
//       ty: 3,
//       nm: 'Null 1',
//       sr: 1,
//       ks: {
//         o: { a: 0, k: 0, ix: 11 },
//         r: {
//           a: 1,
//           k: [
//             { i: { x: [0.35], y: [1] }, o: { x: [0.65], y: [0] }, t: 64, s: [0] },
//             { i: { x: [0.35], y: [1] }, o: { x: [0.65], y: [0] }, t: 104, s: [180] },
//             { i: { x: [0.35], y: [1] }, o: { x: [0.65], y: [0] }, t: 164, s: [180] },
//             { t: 204, s: [360] },
//           ],
//           ix: 10,
//         },
//         p: { a: 0, k: [500, 500, 0], ix: 2, l: 2 },
//         a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
//         s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
//       },
//       ao: 0,
//       ip: 0,
//       op: 611,
//       st: 0,
//       bm: 0,
//     },
//     {
//       ddd: 0,
//       ind: 2,
//       ty: 4,
//       nm: 'New Shape 2',
//       parent: 1,
//       sr: 1,
//       ks: {
//         o: { a: 0, k: 100, ix: 11 },
//         r: { a: 0, k: 0, ix: 10 },
//         p: {
//           a: 1,
//           k: [
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 44, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 64, s: [-150, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 104, s: [-150, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 124, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 144, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 164, s: [0, 150, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 204, s: [0, 150, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { t: 224, s: [0, 0, 0] },
//           ],
//           ix: 2,
//           l: 2,
//         },
//         a: { a: 0, k: [10, 10, 0], ix: 1, l: 2 },
//         s: { a: 0, k: [1144, 1144, 100], ix: 6, l: 2 },
//       },
//       ao: 0,
//       shapes: [
//         {
//           ty: 'gr',
//           it: [
//             {
//               ind: 0,
//               ty: 'sh',
//               ix: 1,
//               ks: {
//                 a: 0,
//                 k: {
//                   i: [
//                     [0, 0],
//                     [6.624, 0],
//                     [0, 0],
//                     [0, 4.379],
//                     [0, 0],
//                     [-6.115, 0],
//                     [0, 0],
//                     [0, -4.615],
//                   ],
//                   o: [
//                     [0, -4.615],
//                     [0, 0],
//                     [6.624, 0],
//                     [0, 0],
//                     [0, 4.379],
//                     [0, 0],
//                     [-6.115, 0],
//                     [0, 0],
//                   ],
//                   v: [
//                     [-0.573, 10],
//                     [-10, 0.888],
//                     [-10, -0.533],
//                     [-0.573, -10],
//                     [0.955, -10],
//                     [10, -0.533],
//                     [10, 0.888],
//                     [0.955, 10],
//                   ],
//                   c: true,
//                 },
//                 ix: 2,
//               },
//               nm: 'Path 1',
//               mn: 'ADBE Vector Shape - Group',
//               hd: false,
//             },
//             {
//               ty: 'fl',
//               c: { a: 0, k: [0.023529411765, 0.243137254902, 0.286274509804, 1], ix: 4 },
//               o: { a: 0, k: 100, ix: 5 },
//               r: 1,
//               bm: 0,
//               nm: 'Fill 1',
//               mn: 'ADBE Vector Graphic - Fill',
//               hd: false,
//             },
//             {
//               ty: 'tr',
//               p: { a: 0, k: [10, 10], ix: 2 },
//               a: { a: 0, k: [0, 0], ix: 1 },
//               s: { a: 0, k: [100, 100], ix: 3 },
//               r: { a: 0, k: 0, ix: 6 },
//               o: { a: 0, k: 100, ix: 7 },
//               sk: { a: 0, k: 0, ix: 4 },
//               sa: { a: 0, k: 0, ix: 5 },
//               nm: 'Transform',
//             },
//           ],
//           nm: 'Group 1',
//           np: 2,
//           cix: 2,
//           bm: 0,
//           ix: 1,
//           mn: 'ADBE Vector Group',
//           hd: false,
//         },
//       ],
//       ip: 0,
//       op: 611,
//       st: 0,
//       ct: 1,
//       bm: 0,
//     },
//     {
//       ddd: 0,
//       ind: 3,
//       ty: 4,
//       nm: 'New Shape',
//       parent: 1,
//       sr: 1,
//       ks: {
//         o: { a: 0, k: 100, ix: 11 },
//         r: { a: 0, k: 0, ix: 10 },
//         p: {
//           a: 1,
//           k: [
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 44, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 64, s: [150, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 104, s: [150, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 124, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 144, s: [0, 0, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 0.35 }, o: { x: 0.65, y: 0.65 }, t: 164, s: [0, -150, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { i: { x: 0.35, y: 1 }, o: { x: 0.65, y: 0 }, t: 204, s: [0, -150, 0], to: [0, 0, 0], ti: [0, 0, 0] },
//             { t: 224, s: [0, 0, 0] },
//           ],
//           ix: 2,
//           l: 2,
//         },
//         a: { a: 0, k: [10, 10, 0], ix: 1, l: 2 },
//         s: { a: 0, k: [1144, 1144, 100], ix: 6, l: 2 },
//       },
//       ao: 0,
//       shapes: [
//         {
//           ty: 'gr',
//           it: [
//             {
//               ind: 0,
//               ty: 'sh',
//               ix: 1,
//               ks: {
//                 a: 0,
//                 k: {
//                   i: [
//                     [0, 0],
//                     [6.624, 0],
//                     [0, 0],
//                     [0, 4.379],
//                     [0, 0],
//                     [-6.115, 0],
//                     [0, 0],
//                     [0, -4.615],
//                   ],
//                   o: [
//                     [0, -4.615],
//                     [0, 0],
//                     [6.624, 0],
//                     [0, 0],
//                     [0, 4.379],
//                     [0, 0],
//                     [-6.115, 0],
//                     [0, 0],
//                   ],
//                   v: [
//                     [-0.573, 10],
//                     [-10, 0.888],
//                     [-10, -0.533],
//                     [-0.573, -10],
//                     [0.955, -10],
//                     [10, -0.533],
//                     [10, 0.888],
//                     [0.955, 10],
//                   ],
//                   c: true,
//                 },
//                 ix: 2,
//               },
//               nm: 'Path 1',
//               mn: 'ADBE Vector Shape - Group',
//               hd: false,
//             },
//             {
//               ty: 'fl',
//               c: { a: 0, k: [0.023529411765, 0.243137254902, 0.286274509804, 1], ix: 4 },
//               o: { a: 0, k: 100, ix: 5 },
//               r: 1,
//               bm: 0,
//               nm: 'Fill 1',
//               mn: 'ADBE Vector Graphic - Fill',
//               hd: false,
//             },
//             {
//               ty: 'tr',
//               p: { a: 0, k: [10, 10], ix: 2 },
//               a: { a: 0, k: [0, 0], ix: 1 },
//               s: { a: 0, k: [100, 100], ix: 3 },
//               r: { a: 0, k: 0, ix: 6 },
//               o: { a: 0, k: 100, ix: 7 },
//               sk: { a: 0, k: 0, ix: 4 },
//               sa: { a: 0, k: 0, ix: 5 },
//               nm: 'Transform',
//             },
//           ],
//           nm: 'Group 1',
//           np: 2,
//           cix: 2,
//           bm: 0,
//           ix: 1,
//           mn: 'ADBE Vector Group',
//           hd: false,
//         },
//       ],
//       ip: 0,
//       op: 611,
//       st: 0,
//       ct: 1,
//       bm: 0,
//     },
//   ],
//   markers: [],
//   props: {},
// };

// lottie.loadAnimation({
//   container: document.getElementById('page-loader'),
//   renderer: 'svg',
//   loop: true,
//   autoplay: true,
//   animationData,
// });
